import { network } from 'services/network';

export const getUnreadCounter = () => {
    return network.post('api/bo/notification/getUnreadCounter').then((response) => response.data);
};
